<mat-accordion [multi]="false" class="custom-accordion">
  <mat-expansion-panel
    *ngFor="let item of accordionItems; trackBy: trackByFn"
    class="custom-panel"
    [ngClass]="{
      'selected-panel': item.id === selectedId,
      'panel-reorder-mode': isReorderMode(item.id!),
    }"
    [expanded]="item.expanded"
    [disabled]="item.disabled"
    (opened)="onPanelOpened(item)"
    (closed)="onPanelClosed(item)"
  >
    <mat-expansion-panel-header class="panel-header">
      <div class="header-content">
        <span class="panel-title">{{ item.title }}</span>
      </div>

      <div class="header-actions">
        <button
          *ngIf="item.links && item.links.length > 1"
          mat-stroked-button
          class="reorder-toggle-btn me-1"
          [class.reorder-toggle-btn--active]="isReorderMode(item.id!)"
          [disabled]="isLoadingReorder(item.id!)"
          (click)="toggleLinkReorderMode(item, $event)"
        >
          <mat-spinner
            [hidden]="!isLoadingReorder(item.id!)"
            diameter="14"
          ></mat-spinner>
          <i
            [hidden]="isLoadingReorder(item.id!)"
            class="fa-solid me-1"
            [class.fa-arrows-up-down]="!isReorderMode(item.id!)"
            [class.fa-check]="isReorderMode(item.id!)"
          ></i>
          <span [hidden]="isLoadingReorder(item.id!)">
            {{ isReorderMode(item.id!) ? "Save Order" : "Re-Order" }}
          </span>
        </button>

        <button
          mat-icon-button
          class="action-btn"
          [matMenuTriggerFor]="actionMenu"
          [matTooltip]="'More Actions'"
          (click)="$event.stopPropagation()"
        >
          <i
            [class]="'action-icon ' + (item.actionIcon || 'fas fa-ellipsis-v')"
          ></i>
        </button>

        <mat-menu #actionMenu="matMenu" class="action-menu">
          <button
            mat-menu-item
            (click)="onMenuAction('addAccordion', item, $event)"
          >
            <i class="fas fa-plus menu-icon"></i> <span>Add Accordion</span>
          </button>
          <button
            mat-menu-item
            (click)="onMenuAction('uploadFile', item, $event)"
          >
            <i class="fas fa-upload menu-icon"></i> <span>Upload File</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('link', item, $event)">
            <i class="fas fa-link menu-icon"></i> <span>Add Link</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('addText', item, $event)">
            <i class="fas fa-align-left menu-icon"></i> <span>Add Text</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('edit', item, $event)">
            <i class="fas fa-edit menu-icon"></i> <span>Edit</span>
          </button>
          <button mat-menu-item (click)="onMenuAction('delete', item, $event)">
            <i class="fas fa-trash menu-icon"></i> <span>Delete</span>
          </button>
          <ng-container *ngIf="item.menuActions">
            <mat-divider></mat-divider>
            <button
              *ngFor="let menuAction of item.menuActions"
              mat-menu-item
              (click)="onMenuAction(menuAction.action, item, $event)"
              [disabled]="menuAction.disabled"
            >
              <i [class]="'menu-icon ' + menuAction.icon"></i>
              <span>{{ menuAction.label }}</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </mat-expansion-panel-header>

    <ng-container *ngIf="item.links && item.links.length > 0">
      <div
        class="links-section"
        cdkDropList
        [cdkDropListDisabled]="!isReorderMode(item.id!)"
        (cdkDropListDropped)="dropLink($event, item)"
      >
        <div
          *ngFor="let link of item.links; trackBy: trackLinkByFn"
          class="link-item px-2 d-flex"
          [class.align-items-center]="link.type !== 'TEXT'"
          [class.align-items-start]="link.type === 'TEXT'"
          [class.reorder-active]="isReorderMode(item.id!)"
          cdkDrag
          [cdkDragDisabled]="!isReorderMode(item.id!)"
        >
          <mat-icon
            class="drag-handle me-2"
            [class.drag-handle--top]="link.type === 'TEXT'"
            [hidden]="!isReorderMode(item.id!)"
            cdkDragHandle
            >drag_indicator</mat-icon
          >

          <div
            *ngIf="link.type === 'TEXT'; else linkOrFileRow"
            class="flex-grow-1 d-flex align-items-start text-item-row"
          >
            <i
              [class]="
                'link-icon me-2 flex-shrink-0 ' +
                (link.icon || 'fas fa-align-left')
              "
              style="margin-top: 4px"
            ></i>

            <span
              class="text-item-body text-truncate-multiline"
              [matTooltip]="link.content || link.label"
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip-style"
            >
              {{ link.content || link.label }}
            </span>
          </div>

          <ng-template #linkOrFileRow>
            <a
              [href]="link.url"
              target="_blank"
              rel="noopener noreferrer"
              class="flex-grow-1 d-flex align-items-center text-decoration-none link-row"
              (click)="onLinkClick($event, link)"
            >
              <i *ngIf="link.icon" [class]="'link-icon me-2 ' + link.icon"></i>
              <span
                class="link-label"
                [matTooltip]="link.url"
                matTooltipPosition="above"
                >{{ link.label || link.url }}</span
              >
            </a>
          </ng-template>

          <button
            *ngIf="!isReorderMode(item.id!)"
            mat-icon-button
            class="link-action-btn"
            [matMenuTriggerFor]="linkMenu"
            (click)="$event.stopPropagation()"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>

          <mat-menu #linkMenu="matMenu">
            <button mat-menu-item (click)="onLinkMenuAction('view', link)">
              <i class="fas fa-eye me-2"></i><span>View</span>
            </button>
            <button mat-menu-item (click)="onLinkMenuAction('delete', link)">
              <i class="fas fa-trash me-2"></i><span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="item.children && item.children.length > 0">
      <app-expansion-panel
        [items]="item.children"
        [nestedLevel]="nestedLevel + 1"
        [selectedId]="selectedId"
        (itemExpanded)="itemExpanded.emit($event)"
        (itemCollapsed)="itemCollapsed.emit($event)"
        (linkClicked)="linkClicked.emit($event)"
        (actionClicked)="actionClicked.emit($event)"
        (filesReordered)="filesReordered.emit($event)"
      ></app-expansion-panel>
    </ng-container>
  </mat-expansion-panel>
</mat-accordion>
